import { getPublicSiteBaseUrl } from '../../utils/publicSiteUrl';

/** VIP links open the public application, including when admin uses a subdomain. */
export function vipSurveyLink(code: string): string {
  const configured = process.env.REACT_APP_PUBLIC_SITE_URL?.trim() || process.env.REACT_APP_SITE_URL?.trim();
  const hostname = typeof window === 'undefined' ? '' : window.location.hostname;
  const isLocal = hostname === 'localhost' || hostname === '127.0.0.1' ||
    /^192\.168\.\d{1,3}\.\d{1,3}$/.test(hostname) || /^10\.\d{1,3}\.\d{1,3}\.\d{1,3}$/.test(hostname) ||
    /^172\.(1[6-9]|2\d|3[01])\.\d{1,3}\.\d{1,3}$/.test(hostname);
  const origin = configured || (isLocal ? getPublicSiteBaseUrl() : 'https://manehaghighi.com');
  return `${origin.replace(/\/+$/, '')}/v/${encodeURIComponent(code)}`;
}
